/**
 * Datapoint configurations for regional quick settings
 */
export default {
    CurrentTimeZoneQuick: {
        datapoint: {
            name: 'CurrentTimeZoneQuick',
            customData: (currentTimeZone: string) => ({
                currentTimeZone,
            }),
        },
    },

    DateFormatQuick: {
        datapoint: {
            name: 'DateFormatQuick',
            customData: (dateFormat: string) => ({
                dateFormat,
            }),
        },
    },

    TimeFormatQuick: {
        datapoint: {
            name: 'TimeFormatQuick',
            customData: (timeFormat: string) => ({
                timeFormat,
            }),
        },
    },
};
